<template>
    <div :style="{'height': $parentInfo.clientHeight-550+$parentInfo.heightChange+'px'}">
        <div class="m-portlet" v-loading="$parentInfo.studentWallet.loading" style="margin-top: -15px">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <el-tag type="success" style="margin-right: 10px" @click="handleGetBalanceDetail">余额：{{$parentInfo.studentWallet.hasMoney}}
                        </el-tag>
                        <el-tag type="success" style="margin-right: 10px">
                            纠纷余额：{{$parentInfo.studentWallet.disputeMoney}}
                        </el-tag>
                        <el-tag type="success" style="margin-right: 10px" @click="handleChangeCoupon" v-if="$parentInfo.isHeadTeacher">
                            优惠券：{{$parentInfo.studentWallet.couponMoney}}
                        </el-tag>
                        <el-tag type="success" style="margin-right: 10px" v-else>
                            优惠券：{{$parentInfo.studentWallet.couponMoney}}
                        </el-tag>

                        <el-tag type="success" style="margin-right: 10px" @click="handleCashCoupon" v-if="$parentInfo.powers.includes(165)">
                            线下现金优惠：{{$parentInfo.studentWallet.sum_offline_cashCoupon}}
                        </el-tag>
                        <el-tag type="success" style="margin-right: 10px" v-else>
                            线下现金优惠：{{$parentInfo.studentWallet.sum_offline_cashCoupon}}
                        </el-tag>


                        <el-tag type="success" style="margin-right: 10px" >
                            线上现金优惠：{{$parentInfo.studentWallet.sum_online_cashCoupon}}
                        </el-tag>

                        <el-tag type="success" style="margin-right: 10px">
                            押金：{{$parentInfo.studentWallet.sum_deposit}}
                        </el-tag>

                        <el-tag type="success" style="margin-right: 10px">
                            定金：{{$parentInfo.studentWallet.sum_earnest}}
                        </el-tag>

                        <el-tag type="success" style="margin-right: 10px">
                            已购线上课次：{{$parentInfo.studentWallet.all_online_period}}
                        </el-tag>
                    </div>
                </div>
                <div class="m-portlet__head-tools">
                    <ul class="m-portlet__nav">
                        <li class="m-portlet__nav-item">
                            <el-button type="primary" @click="handleClassHourRetired()">课次管理</el-button>
                        </li>
                        <li class="m-portlet__nav-item">
                            <el-button type="primary" @click="handleLessonRetired()">课时退费</el-button>
                        </li>
<!--                        <li class="m-portlet__nav-item">-->
<!--                            <el-button type="primary" @click="handleWalletAddCash('walletAddCash')">充值提现</el-button>-->
<!--                        </li>-->
                    </ul>
                </div>
            </div>

            <div class="m-portlet__body" style="margin-top: -20px">
                <el-tabs v-model="$parentInfo.studentWallet.activeTab">
                    <el-tab-pane label="课时信息" name="1">
                        <vue-scroll :ops="$ops" :style="{'height': 250+$parentInfo.heightChange+'px'}">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>课时ID</th>
                                    <th>年级</th>
                                    <th>学科</th>
                                    <th>班型</th>
                                    <th>购买日期</th>
                                    <th>购买课时</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in orderStudentPeriods" :key="item.id">
                                    <td>{{item.id}}</td>
                                    <td v-if="item.grade">{{item.grade.name}}</td>
                                    <td v-else>年级缺失</td>
                                    <td v-if="item.subject">{{item.subject.name}}</td>
                                    <td v-else>学科缺失</td>
                                    <td v-if="item.class_type">{{item.class_type.name}}</td>
                                    <td v-else>班级类型缺失</td>
                                    <td>{{item.created_at}}</td>
                                    <td>{{item.period}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </vue-scroll>
                    </el-tab-pane>
                    <el-tab-pane label="账单" name="2">
                        <vue-scroll :ops="$ops" :style="{'height': 280+$parentInfo.heightChange+'px'}">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>流水号</th>
                                    <th>日期</th>
                                    <th>支付类型</th>
                                    <th>原因</th>
                                    <th>金钱</th>
                                    <th v-if="$parentInfo.powers.includes(149)">操作</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in orderStudentBalances" :key="item.id">
                                    <td>{{item.id}}</td>
                                    <td>{{item.created_at}}</td>
                                    <td v-if="item.payment_type">{{item.payment_type.name}}</td>
                                    <td v-else>支付类型缺失</td>
                                    <td>{{item.remark}}</td>
                                    <td>{{item.balance}}</td>
                                    <td><el-button  @click="handleRollback(item.id)" v-if="item.type=='refund' && cancel_status.includes(item.cancel_status) && $parentInfo.powers.includes(149)">撤回</el-button></td>
                                </tr>
                                </tbody>
                            </table>
                        </vue-scroll>
                    </el-tab-pane>
                    <el-tab-pane label="优惠券" name="3">
                        <vue-scroll :ops="$ops" :style="{'height': 280+$parentInfo.heightChange+'px'}">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>编号</th>
                                    <th>获取日期</th>
                                    <th>结束日期</th>
                                    <th>金额</th>
                                    <th>原因</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in orderStudentCoupons" :key="item.id">
                                    <td>{{item.id}}</td>
                                    <td>{{item.getDate}}</td>
                                    <td>{{item.endDate}}</td>
                                    <td>{{item.money}}</td>
                                    <td>{{item.remark}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </vue-scroll>
                    </el-tab-pane>
                    <el-tab-pane label="现金优惠" name="5">
                        <vue-scroll :ops="$ops" :style="{'height': 280+$parentInfo.heightChange+'px'}">
                            <table class="table" v-loading="$parentInfo.studentWallet.loading">
                                <thead>
                                <tr>
                                    <th>编号</th>
                                    <th>获取日期</th>
                                    <th>结束日期</th>
                                    <th>金额</th>
                                    <th>状态</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in orderCashCoupons" :key="item.id">
                                    <td>{{item.id}}</td>
                                    <td>{{item.start_date}}</td>
                                    <td>{{item.end_date}}</td>
                                    <td>{{item.balance}}</td>
                                    <td v-if="item.status==='active'">生效</td>
                                    <td v-else>失效</td>
                                </tr>
                                </tbody>
                            </table>
                        </vue-scroll>
                    </el-tab-pane>
                    <el-tab-pane label="折扣优惠" name="6">
                        <vue-scroll :ops="$ops" :style="{'height': 280+$parentInfo.heightChange+'px'}">
                            <table class="table" v-loading="$parentInfo.studentWallet.loading">
                                <thead>
                                <tr>
                                    <th>编号</th>
                                    <th>获取日期</th>
                                    <th>结束日期</th>
                                    <th>折扣</th>
                                    <th>状态</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in orderDiscountCoupons" :key="item.id">
                                    <td>{{item.id}}</td>
                                    <td>{{item.start_date}}</td>
                                    <td>{{item.end_date}}</td>
                                    <td>{{item.discount}}</td>
                                    <td v-if="item.status==='active'">生效</td>
                                    <td v-else>失效</td>
                                </tr>
                                </tbody>
                            </table>
                        </vue-scroll>
                    </el-tab-pane>
                    <el-tab-pane label="课次信息" name="7">
                        <vue-scroll :ops="$ops" :style="{'height': 280+$parentInfo.heightChange+'px'}">
                            <table class="table" v-loading="$parentInfo.studentWallet.loading">
                                <thead>
                                <tr>
                                    <th>编号</th>
                                    <th>学期</th>
                                    <th>年级</th>
                                    <th>时长</th>
                                    <th>原价</th>
                                    <th>折后价</th>
                                    <th>课时数</th>
                                    <th>总价</th>
                                    <th>状态</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in orderStudentClassHours" :key="item.id">
                                    <td>{{item.id}}</td>
                                    <td>{{item.semester_name}}</td>
                                    <td>{{item.grade_name}}</td>
                                    <td>{{item.time}}</td>
                                    <td>{{item.original_unit_period_price}}</td>
                                    <td>{{item.unit_period_price}}</td>
                                    <td>{{item.period}}</td>
                                    <td>{{item.sum_price}}</td>
                                    <td v-if="item.status=='active'">已购买</td>
                                    <td v-else>废弃</td>
                                </tr>
                                </tbody>
                            </table>
                        </vue-scroll>
                    </el-tab-pane>
                    <el-tab-pane label="物品信息" name="8">
                        <vue-scroll :ops="$ops" :style="{'height': 280+$parentInfo.heightChange+'px'}">
                            <table class="table" v-loading="$parentInfo.studentWallet.loading">
                                <thead>
                                <tr>
                                    <th>合同编号</th>
                                    <th>物品名</th>
                                    <th>序列号</th>
                                    <th>数量</th>
                                    <th>总价</th>
                                    <th>创建日期</th>
                                    <th>类型</th>
                                    <th>是否分配</th>
                                    <th>状态</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="item in orderStudentShops" :key="item.id">
                                    <td>{{item.invoice_id}}</td>
                                    <td>{{item.shop_name}}</td>
                                    <td>{{item.serial_id}}</td>
                                    <td>{{item.amount}}</td>
                                    <td>{{item.sum_price}}</td>
                                    <td>{{item.borrow_date}}</td>
                                    <td v-if="item.invoice_state==2">出租</td>
                                    <td v-else>出售</td>
                                    <td v-if="item.state==1">已分配</td>
                                    <td v-else>未分配</td>
                                    <td v-if="item.return_date">已还</td>
                                    <td v-else>未还</td>
                                </tr>
                                </tbody>
                            </table>
                        </vue-scroll>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                cancel_status:['refund_classPlan','refund_classPlan_all']
            };
        },
        computed: {
            orderStudentBalances: function () {
                return this._.orderBy(this.$parentInfo.studentWallet.studentBalances, 'id', 'desc');
            },
            orderStudentPeriods: function () {
                return this._.orderBy(this.$parentInfo.studentWallet.studentPeriods, 'id', 'desc');
            },
            orderStudentCoupons: function () {
                return this._.orderBy(this.$parentInfo.studentWallet.studentCoupons, 'id', 'desc');
            },
            orderCashCoupons: function () {
                return this._.orderBy(this.$parentInfo.studentWallet.cashCoupons, 'id', 'desc');
            },
            orderDiscountCoupons: function () {
                return this._.orderBy(this.$parentInfo.studentWallet.discountCoupons, 'id', 'desc');
            },
            orderStudentClassHours: function () {
                return this._.orderBy(this.$parentInfo.studentWallet.studentClassHours, 'id', 'desc');
            },
            orderStudentShops: function () {
                return this._.orderBy(this.$parentInfo.studentWallet.studentShops, 'id', 'desc');
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleShowStudentBalance();
        },
        methods: {
            handleShowStudentBalance() {
                this.$wApi.send(this.$parentInfo.path, 'studentWallet', {
                    'student_id': this.$parentInfo.student_id,
                });
            },
            handleWalletAddCash() {
                this.$Win.openModal('Dialog_WalletAddCash', 700, 600, '充值提现', {
                    'hasMoney': this.$parentInfo.studentWallet.hasMoney,
                    'disputeMoney': this.$parentInfo.studentWallet.disputeMoney,
                });
            },
            handleClassHourRetired(){
                this.$Win.openModal('Dialog_ClassHourRetired', 600, 700, '课次');
            },
            handleLessonRetired() {
                this.$Win.openModal('Dialog_LessonRetired', 600, 700, '课时');
            },
            handleGetBalanceDetail(){
                this.$Win.openModal('Dialog_BalanceDetail', 600, 700, '余额详情');
            },
            handleChangeCoupon(){
                if(this.$parentInfo.studentWallet.couponMoney>0){
                    this.$confirm('确认转换为个人现金优惠?', '提示', {
                        StartReturn: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.$wApi.send(this.$parentInfo.path, 'changeCoupon', {
                            'student_id': this.$parentInfo.student_id,
                        });
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消'
                        });
                    });
                }

            },
            handleRollback(balance_id){
                this.$wApi.send(this.$parentInfo.path, 'cancelRefund', {
                    'balance_id': balance_id,
                });
            },
            handleCashCoupon(){
                this.$Win.openModal('Dialog_UpdateCashCoupon', 400, 400, '现金优惠充值提现', {
                    'sum_cashCoupon': this.$parentInfo.studentWallet.sum_cashCoupon,
                });
            },
            handleStoreDeposit(){
                this.$Win.openModal('Dialog_StoreDeposit', 400, 400, '押金充值',{});
            }
        }
    };
</script>

<style scoped>
</style>
